import React, { useState, useEffect } from "react";
import CustomDataTable from "../../../../partials/content/CustomDataTable";
import { formatDate } from "../../../../utils/utils";
import Illustration from "../../../../partials/content/Illustration";
import ContentLayout from "../../../../partials/content/ContentLayout";
import {
  getIncomingPayments,
  cancelIncomingPayment,
} from "../../../../services/finance/incomingPayment";
import ResponsiveEllipsis from "../../../../partials/content/ResponsiveEllipsis";
import BootstrapTooltip from "../../../../partials/content/BootstrapTooltip";
import NumberFormat from "react-number-format";
import { Badge } from "react-bootstrap";
import Swal from "sweetalert2";
import { useGlobalData } from "../../../../../provider/GlobalDataProvider";
const IncomingPaymentList = ({ history }) => {
  const { reload } = useGlobalData();
  const [incomingPayments, setIncomingPayments] = useState([]);
  const [auth, setAuth] = useState({ create: false });
  useEffect(() => {
    getIncomingPaymentsData();
  }, [reload]);

  async function getIncomingPaymentsData() {
    const response = await getIncomingPayments();
    const { data, auth } = response.data;
    setAuth(auth);
    setIncomingPayments(data.incomingPayments);
  }

  const incomingPaymentDetailColumn = [
    {
      header: "Exchange Rate To Base Currency",
      field: "exchangeRate",
      type: "currency",
    },
    {
      header: "Created At",
      field: "CreatedAt",
      type: "datetime",
    },
    {
      header: "Created By",
      field: "createdByName",
      type: "string",
    },
    {
      header: "Updated At",
      field: "UpdatedAt",
      type: "datetime",
    },
    {
      header: "Updated By",
      field: "updatedByName",
      type: "string",
    },
  ];

  return (
    <React.Fragment>
      <ContentLayout>
        {incomingPayments.length ? (
          <React.Fragment>
            <CustomDataTable
              data={incomingPayments}
              dataDetailColumns={incomingPaymentDetailColumn}
              onRefreshData={() => {
                getIncomingPaymentsData();
              }}
              tableName="incomingPayment"
              selectionMode="checkbox"
              columns={[
                {
                  selectionMode: "multiple",
                },
                {
                  header: "A/R Payment ID",
                  field: "incomingPaymentCode",
                  body: null,
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Customer Name",
                  field: "customer.customerName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.customer.customerName}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Payment Date",
                  field: "paymentDate",
                  body: (rowData) => formatDate(rowData.paymentDate),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "A/R Invoice ID",
                  field: "invoiceCode",
                  body: null,
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Cash Account",
                  field: "glAccount.accountName",
                  body: (rowData) => (
                    <React.Fragment>
                      <ResponsiveEllipsis
                        text={rowData.glAccount.accountName}
                        maxLine="1"
                      />
                    </React.Fragment>
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Currency",
                  field: "currency.currencyCode",
                  body: null,
                  sortable: true,
                  filter: true,
                  hidden: true,
                },
                {
                  header: "Payment Amount",
                  field: "paymentAmount",
                  body: (rowData) => (
                    <NumberFormat
                      value={rowData.paymentAmount}
                      displayType={"text"}
                      thousandSeparator={true}
                      decimalScale={2}
                      renderText={(value) => (
                        <div className="float-right">
                          {rowData.currency.currencyCode} {value}
                        </div>
                      )}
                    />
                  ),
                  sortable: true,
                  filter: true,
                },
                {
                  header: "Actions",
                  body: (rowData) => (
                    <React.Fragment>
                      {rowData.view ? (
                        <BootstrapTooltip title="Account Receivable Payment Detail">
                          <button
                            type="button"
                            onClick={() => {
                              history.push(
                                "/finance/incoming-payment-detail/" + rowData.ID
                              );
                            }}
                            className="btn btn-icon btn-label-success btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-list-alt"></i>
                          </button>
                        </BootstrapTooltip>
                      ) : null}
                      {rowData.edit ? (
                        <BootstrapTooltip title="Delete Account Receivable Payment">
                          <button
                            type="button"
                            onClick={() =>
                              handleDeleteIncomingPayment(rowData.ID)
                            }
                            className="btn btn-icon btn-label-danger btn-circle btn-md mx-1"
                          >
                            <i className="fas fa-trash-alt"></i>
                          </button>
                        </BootstrapTooltip>
                      ) : null}
                    </React.Fragment>
                  ),
                  sortable: false,
                },
              ]}
            />
          </React.Fragment>
        ) : (
          <Illustration
            imageSource="INVIFO Payment.png"
            description="Hooray! You're ready to have your first Account Receivable Payment!"
            guidance="Hint: manage your A/R payments from customers to be more professional"
            descriptionLeftIcon="fas fa-info-circle kt-font-success"
          ></Illustration>
        )}
      </ContentLayout>
    </React.Fragment>
  );

  async function handleDeleteIncomingPayment(incomingPaymentID = 0) {
    Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success btn-md btn-pill btn-bold",
        cancelButton: "btn btn-danger btn-md btn-pill btn-bold",
      },
      buttonsStyling: false,
    })
      .fire({
        title: "Are you sure want to delete this Account Receivable Payment ?",
        text: "Please note that you are responsible for this action",
        icon: "question",
        showCloseButton: true,
        showCancelButton: true,
        confirmButtonText: `<i class="fas fa-check-circle"></i> Yes, delete it`,
        cancelButtonText: `<i class="fas fa-times-circle"></i> No, cancel`,
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          cancelIncomingPayment(incomingPaymentID).then((response) => {
            Swal.mixin({
              customClass: {
                confirmButton: "btn btn-success btn-md btn-pill btn-bold",
              },
              buttonsStyling: false,
            }).fire({
              title: "Deleted",
              html: response.data.message,
              icon: "success",
              showCloseButton: true,
              confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
            });
            getIncomingPaymentsData();
          });
        } else if (result.dismiss === Swal.DismissReason.cancel) {
          Swal.mixin({
            customClass: {
              confirmButton: "btn btn-success btn-md btn-pill btn-bold",
            },
            buttonsStyling: false,
          }).fire({
            title: "Cancelled",
            text: "No change has been made",
            icon: "info",
            showCloseButton: true,
            confirmButtonText: `<i class="fas fa-check-circle"></i> Okay, noted`,
          });
        }
      });
  }
};

export default IncomingPaymentList;
